import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

// Hide the default cursor when our custom cursor is active
const GlobalCursorStyle = createGlobalStyle`
  @media (min-width: 769px) {
    body {
      cursor: none !important;
    }
    
    a, button, [role="button"], input, select, textarea, [tabindex]:not([tabindex="-1"]) {
      cursor: none !important;
    }
  }
`;

const CarCursorContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 30px;
  height: 15px;
  pointer-events: none;
  z-index: 9999;
  transform: translate(-50%, -50%);
  transition: transform 0.1s ease;
  
  &.hovering {
    transform: translate(-50%, -50%) scale(1.2);
  }
`;

const CarSvg = styled.svg`
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 2px 5px rgba(0, 225, 199, 0.5));
`;

const CarCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    // Check if device is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkMobile();
    
    // Listen for resize events
    window.addEventListener('resize', checkMobile);
    
    // Show cursor only after it's positioned correctly to avoid initial jump
    const timer = setTimeout(() => setIsVisible(true), 100);
    
    const updatePosition = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };
    
    const updateHoverState = (e) => {
      const target = e.target;
      const isHoverable =
        target.tagName === 'A' ||
        target.tagName === 'BUTTON' ||
        target.getAttribute('role') === 'button' ||
        target.tagName === 'INPUT' ||
        target.tagName === 'SELECT' ||
        target.tagName === 'TEXTAREA' ||
        (target.getAttribute('tabindex') && target.getAttribute('tabindex') !== '-1');
      
      setIsHovering(isHoverable);
    };
    
    window.addEventListener('mousemove', updatePosition);
    window.addEventListener('mouseover', updateHoverState);
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('mousemove', updatePosition);
      window.removeEventListener('mouseover', updateHoverState);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  
  // Don't render cursor on mobile devices
  if (!isVisible || isMobile) return null;
  
  return (
    <>
      <GlobalCursorStyle />
      <CarCursorContainer 
        style={{ left: `${position.x}px`, top: `${position.y}px` }}
        className={isHovering ? 'hovering' : ''}
      >
        <CarSvg viewBox="0 0 30 15" xmlns="http://www.w3.org/2000/svg">
          {/* Car body */}
          <rect x="5" y="5" width="20" height="7" rx="2" fill="#00e1c7" />
          
          {/* Car roof */}
          <rect x="8" y="2" width="14" height="3" rx="1" fill="#00e1c7" />
          
          {/* Windows */}
          <rect x="10" y="3" width="3" height="2" rx="1" fill="#0a1a1f" />
          <rect x="17" y="3" width="3" height="2" rx="1" fill="#0a1a1f" />
          
          {/* Wheels */}
          <circle cx="8" cy="12" r="2" fill="#0a1a1f" />
          <circle cx="22" cy="12" r="2" fill="#0a1a1f" />
          
          {/* Headlights */}
          <circle cx="25" cy="7" r="1" fill="#fff" />
          <circle cx="5" cy="7" r="1" fill="#fff" />
        </CarSvg>
      </CarCursorContainer>
    </>
  );
};

export default CarCursor;